import { gql, useQuery } from '@apollo/client';
import { useFetch } from '../../../utils/useFetch';
import {
  GetQualifiersQuery,
  GetQualifiersQueryVariables,
} from '../../../__generated__/queries-web';

export const GET_QUALIFIERS = gql`
  query GetQualifiers(
    $first: UnsignedInt!
    $where: QualifierFilterInput
    $orderBy: [QualifierOrderingInput!]
  ) {
    qualifiers(first: $first, where: $where, orderBy: $orderBy) {
      id
      title
      status
      brandKey
      format
      type
    }
  }
`;

export const useQualifiers = (
  variables: GetQualifiersQueryVariables,
  skip?: boolean,
) => {
  return useQuery<GetQualifiersQuery, GetQualifiersQueryVariables>(
    GET_QUALIFIERS,
    {
      variables,
      skip,
    },
  );
};

export const useQualifiersGetter = () =>
  useFetch<GetQualifiersQuery, GetQualifiersQueryVariables>(GET_QUALIFIERS);
